import {getFranchiseWeblocationID} from "./getFranchiseWeblocationId";
import {getFullAttribute} from "./getFullAttribute";
import {get_data,getRefDetails,stop_loader} from "../util";
import { refreshCalendarData, schedulerState } from "../calendar";
import { setProgressBar } from "../scheduler";
import { setProgressBarDisplay } from "./setProgressBarDisplay";
export function getFranchiseWeblocation(){
    var postalCode =window.objOSGlobal.requestBodyValues.PostalCode;
    var address = $('#service-address-screen input[name="address"]').val();
    var apartment = $('#service-address-screen input[name="address2"]').val();
    var city = $('#service-address-screen input[name="city"]').val();
    var state = $('#service-address-screen select[name="state"]').val();
    apartment = apartment ? apartment + " ": "";
    let addressParam = address + " " + apartment +city + " " + state + " " + postalCode;
    let locationDoingBusinessAs:string;
    let previousSelectedDate:string;

    getFranchiseWeblocationID(addressParam, function(result:any){
        if (result.length == 0){
            $('.progressbar, .progress').hide();
            $('#js-schedulerDialog .modal-header-two').css('display', 'none');
            $('#js-schedulerDialog .modal-header-one').show();
            $('#service-address-screen').removeClass('active');
            $('.scheduler-modal .modal-content').addClass('banner-wizard');
            $('#no-search-result .head-title').html(`We’re sorry. We don’t currently provide service to <span class="noservice-zipcode">${postalCode}</span>`);
            $('#no-search-result').addClass('active');
            sessionStorage.removeItem('changeZip');
            stop_loader();
            return;
        }
        
        window.objOSGlobal.requestBodyValues.WebLocationId = result[0].franchiseWebLocationId;
        window.objOSGlobal.requestBodyValues.FranchiseId = result[0]?.franchiseId;
        const webLocationId = window.objOSGlobal.requestBodyValues.WebLocationId;
        const serviceName = window.objOSGlobal.requestBodyValues.serviceName || get_data('serviceName');
        getFullAttribute(webLocationId, function (result: any)
        {
            stop_loader();
            locationDoingBusinessAs = result.locationDoingBusinessAs;
            if (result.length == 0)
            {
                $('#service-address-screen').removeClass('active');
                $('.scheduler-modal .modal-content').addClass('banner-wizard');
                $('.progressbar, .progress').hide();
                $('#js-schedulerDialog .modal-header-two').css('display', 'none');
                $('#js-schedulerDialog .modal-header-one').show();
                $('#no-search-result').addClass('active');
                $('#no-search-result .head-title').text(`We're sorry. We don't currently provide ${serviceName} at this location`);
                sessionStorage.removeItem('changeZip');
                return;
            }
            if (!window.objOSGlobal.requestBodyValues.IsLeadOnly)
                {
    
                    previousSelectedDate = window.objOSGlobal.paramsUI.selectedDate;
                        schedulerState.numberOfSlot = 1;
                        refreshCalendarData(new Date().getFullYear(), new Date().getMonth() + 1, function (resultData:any)
                        {   stop_loader();
                            let PreviousSelectedDateData:any = {};
                            if(previousSelectedDate){
                                PreviousSelectedDateData = resultData.find((schedule: { startDate: string; }) => schedule.startDate === previousSelectedDate);
                            }
                            else{
                                //1D Alert message
                                updateSchedulerScreen();
                                $('#schedulerWizard #scheduler-available-new-location').addClass('active');
                                return;
                            }
                            
                            if(PreviousSelectedDateData?.['isAvailable']) {
                                //1B Alert message
                                updateSchedulerScreen();
                                $('#schedulerWizard #dt-not-available-new-location').addClass('active');
                            }  
                            else {
                                //1A Alert message
                                updateSchedulerScreen();
                                $('#schedulerWizard #dt-available-new-location').addClass('active');
                            }
                            
                        });
        
        
                } else{
                    //1C Alert message
                    updateSchedulerScreen();
                    $('#schedulerWizard #no-scheduler-available-new-location').addClass('active');
                    
                }           
        });
    });

    function updateSchedulerScreen() {
        $('.progressbar, .progress').hide();
        $('#js-schedulerDialog .modal-header-two').css('display', 'none');
        $('#js-schedulerDialog .modal-header-one').show();
        $('#service-address-screen').removeClass('active');
        $('.scheduler-modal .modal-content').addClass('banner-wizard');
    }
   
    function handleSchedulerClick(activeScreen:any, hideCalendarStep = false) {
        $('#js-schedulerDialog .modal-header-two').css('display', 'flex');
        $('.modal-header-two #schedulermodallabel').text(locationDoingBusinessAs);
        $('.scheduler-modal .modal-content').removeClass('banner-wizard');
        $('.progressbar, .progress').show();
        $('#js-schedulerDialog .modal-header-one').hide();
        $('#schedulerWizard ' + activeScreen).addClass('active');
        $('#js-schedulerDialog .modal-header-two .result-stack-logo, #js-schedulerDialog .modal-header-two #modal-header-contact').removeClass('hidden');
    
        if (hideCalendarStep) {
            $('.progressbar a[data-step="calendar-screen"]').parent().hide();
            $('.progressbar a[data-step="service-details-screen"]').parent().show();
        } else {
            $('.progressbar a[data-step="calendar-screen"]').parent().show();
        }
    }
    
    //1A Flow after alert message
    $('#dt-available-new-location .dt-available-new-location').on('click', function () {
        handleSchedulerClick('#calendar-screen');
        $('#schedulerWizard #dt-available-new-location').removeClass('active');
        $('.progressbar a[data-step="service-address-screen"]').removeClass('active').parent().removeClass('active').addClass('disabled');
        $('.progressbar a[data-step="calendar-screen"]').addClass('active').parent().addClass('active').removeClass('disabled');
        callSetProgressBar();
    });
    //1B Flow after alert message
    $('#dt-not-available-new-location .dt-not-available-new-location').on('click', function () {
        handleSchedulerClick('#service-details-screen');
        $('#schedulerWizard #dt-not-available-new-location').removeClass('active');
        $('.progressbar a[data-step="service-address-screen"]').removeClass('active').parent().removeClass('active').addClass('disabled');
        $('.progressbar a[data-step="service-details-screen"]').addClass('active').parent().addClass('active').removeClass('disabled');
        getRefDetails();
        callSetProgressBar();
    });
    //1C Flow after alert message
    $('#no-scheduler-available-new-location .no-scheduler-available-new-location').on('click', function () {
        handleSchedulerClick('#service-details-screen', true);
        $('#schedulerWizard #no-scheduler-available-new-location').removeClass('active');
        $('.progressbar a[data-step="service-address-screen"]').removeClass('active').parent().removeClass('active').addClass('disabled');
        $('.progressbar a[data-step="service-details-screen"]').addClass('active').parent().addClass('active').removeClass('disabled');
        $('.progressbar li').css('width', 'calc(100%/4)');
        getRefDetails();
        callSetProgressBar(true);
    });

        //1D Flow after alert message
    $('#scheduler-available-new-location .scheduler-available-new-location').on('click', function () {
        handleSchedulerClick('#calendar-screen');
        $('#schedulerWizard #scheduler-available-new-location').removeClass('active');
        $('.progressbar a[data-step="calendar-screen"]').parent().show();
        $('.progressbar a[data-step="service-address-screen"]').removeClass('active').parent().removeClass('active').addClass('disabled');
        $('.progressbar a[data-step="calendar-screen"]').addClass('active').parent().addClass('active').removeClass('disabled');
        callSetProgressBar(true);
    });

    //Function to set the Progress Bar
    function callSetProgressBar(leadFlowChange:boolean=false){
        if(leadFlowChange){
            var code = window.objOSGlobal.requestBodyValues.ConceptCalledId || window.objOSGlobal.requestBodyValues.ConceptCode;
            setProgressBarDisplay(code, window.objOSGlobal.requestBodyValues.IsLeadOnly);
        }
        else{
        let step:any = $('#schedulerWizard .tab-pane.active').attr('id');
        setProgressBar(step);
        }
    }
}
